import React from "react";

function Highlights_Home() {
  return (
    <div className="box highlights-box">
      <div className="wh">
        <h1 className="heading">Highlights</h1>
        <div className="bullet-text">
          <div className="bullet-item">
            ID PhD Guidelines for Comprehensive Examination. Click{" "}
            <span className="inline-link">here</span> to view.
          </div>
          <div className="bullet-item">
            ID PhD Guidelines for Contingency Grant. Click{" "}
            <span className="inline-link">here</span> to view.
          </div>
          <div className="bullet-item">
            CIP @ IITH has introduced new Online M.Tech Courses in various
            disciplines. Details are available under the M.Tech page. Click{" "}
            <span className="inline-link">here</span> for more.
          </div>
          <div className="bullet-item">
            The list of projects/research areas for Interdisciplinary PhD
            admissions has been updated under the PhD admissions tab.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Highlights_Home;
